import { MetadataStyle } from '../../constants/styles';

const metadataStylesBuilder = metadataLength => {
  const metadataStyles = [...Array(metadataLength)].reduce((acc, _, index) => {
    acc[index] = MetadataStyle;
    return acc;
  }, {});

  return metadataStyles;
};

export default metadataStylesBuilder;
